const CustomPointSymbol = ({
    size, color, borderWidth, borderColor,
}: {
    size: number;
    color: string;
    borderWidth: number;
    borderColor: string;
}) => (
    <g>
        <circle fill="#fff" r={size / 2} strokeWidth={borderWidth} stroke={borderColor} />
        <circle
            r={size / 5}
            strokeWidth={borderWidth}
            stroke={borderColor}
            fill={color}
            fillOpacity={0.35}
        />
    </g>
);

export default CustomPointSymbol;
